















































import {Component, Prop, Vue} from "vue-property-decorator";

import CommunityCard from "@/components/community/_communityCard.vue";

import SubscribeBtn from "@/components/community/_subscribeBtn.vue";
import {AxiosError, AxiosResponse} from "axios";
import {mapGetters} from "vuex";
import {User} from "@/types";

@Component({
    components: {CommunityCard, SubscribeBtn},
    computed: {...mapGetters(["user"])},
})
export default class ManageJoinedGroup extends Vue {
    communityList: any = [];
    user!: User;
    unCommunityId: string = ''

    mounted() {
        this.fetch();
    }

    fetch() {

        this.$api.joinedCommunityList(this.$store.getters.user.id)
            .then((res: any) => {
                this.communityList = res;
            })
            .catch((err: any) => {

            })


    }

    unsubscribe(communityId: string) {
        this.$modal.show('deleteConfirm')
        this.unCommunityId = communityId;
    }

    yesUnsubscribe() {
        this.$api.unsubscribe({user_id: this.user.id, community_id: this.unCommunityId})
            .then((res: any) => {
                this.fetch();
            })
            .catch((err: any) => {
                if (err.message) {
                    alert(err.message)
                }
            })
            .finally(() => {
                this.$modal.hide('deleteConfirm')
            })
    }

}
